import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const navItems = [
  { to: '/', label: '首页', icon: 'ri-home-5-line' },
  { to: '/works', label: '作品合集', icon: 'ri-stack-line' },
  { to: '/contestants', label: '选手盘点', icon: 'ri-user-star-line' },
  { to: '/about', label: '关于我们', icon: 'ri-information-line' },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? 'border-b border-background-200/80 bg-background-50/95 backdrop-blur'
          : 'border-b border-transparent bg-background-50'
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between px-4 md:h-[72px] md:px-6">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-black tracking-wide text-foreground-950">黑料大赛</span>
            <span className="mt-0.5 font-label text-[10px] tracking-[0.18em] text-foreground-500">作品合集围观站</span>
          </span>
        </Link>

        <nav aria-label="主导航" className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `flex items-center gap-1.5 whitespace-nowrap rounded-md px-3.5 py-2 font-label text-sm transition-colors ${
                  isActive
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`
              }
            >
              <i className={`${item.icon} text-base`}></i>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <span className="font-label text-xs text-foreground-500">
            第三季 · 征集至 10/30
          </span>
          <Link
            to="/works"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            看热门作品
          </Link>
        </div>

        <button
          type="button"
          aria-label={menuOpen ? '关闭菜单' : '展开菜单'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav aria-label="移动端导航" className="flex flex-col px-4 py-3">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `flex items-center gap-2 rounded-md px-3 py-3 font-label text-sm ${
                    isActive ? 'bg-primary-100 text-primary-700' : 'text-foreground-700'
                  }`
                }
              >
                <i className={`${item.icon} text-lg`}></i>
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/works"
              className="mt-2 rounded-md bg-primary-500 px-3 py-3 text-center font-label text-sm text-background-50"
            >
              看热门作品
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}